/* eslint-disable import/no-anonymous-default-export */

// import { alpha, styled } from '@mui/styles';
import { alpha, styled } from '@mui/material/styles';
import { AppBar, Badge, Box, Icon, Switch, Toolbar } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {
  mainAppBarDimen,
  mainDrawerDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame';
import { ACTION_DARK_MODE } from '../constants';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import {
  setAnchorEl,
  setPopoverFrom,
  setTemplate,
} from '../../../redux/features/popoverSlice';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationTemplate } from '../../reusableUiComponent/NotificationTemplate';
import { SECTION_NOTIFICATIONS } from '../../../constants/sections/sectionConstants';
import { useQuery } from '../../../config/common';

const openMixin = theme => {
  return {
    width: `calc(100% - ${toPixel(mainDrawerDimen.open.width)})`,
    // width: `calc(100% - 140px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  };
};

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

export default props => {
  //global context
  const {
    isToolbarOpen,
    isDark,
    mainDrawerOpen,
    appBarJsx,
    bottomBarJsx,
    isRightDrawerOpen,
  } = useMainFrameState();
  const dispatch = useMainFrameDispatch();
  //end

  const notificationsList = useSelector(
    state => state?.popover?.notificationsList
  );

  const notificationsListSize = notificationsList?.length;

  const { isBottom, isToolbar } = props;

  const reduxDispatch = useDispatch();
  const currentUrl = window.location.href;
  const NVAppBar = styled(AppBar, {
    shouldForwardProp: props => true,
  })(props => {
    const { theme } = props;
    return {
      zIndex: isBottom
        ? theme.zIndex.drawer + 1
        : isRightDrawerOpen
        ? theme.zIndex.drawer + 1
        : theme.zIndex.modal + 1,
      overflow: 'hidden',
      height:
        currentUrl?.includes('dashboard') && !isBottom
          ? '0px'
          : currentUrl?.includes('dashboard') && isBottom
          ? '40px'
          : toPixel(mainAppBarDimen.height),
      width: `calc(100% - ${toPixel(mainDrawerDimen.closed.width)})`,
      backgroundColor: theme.palette.appBarColor,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.leavingScreen,
      // }),
      ...(isBottom && {
        top: 'auto',
        bottom: 0,
      }),
      ...(mainDrawerOpen && openMixin(theme)),
      // ...(isToolbar && isToolbarOpen && {
      //     marginTop: `${mainAppBarDimen.height}px`,
      //     visibility: 'none'
      // })
    };
  });
  return (
    <>
      <Box>
        <NVAppBar>
          <Toolbar
            style={{
              maxHeight: '64px',
              minHeight: currentUrl?.includes('dashboard') ? '40px' : '64px',
            }}
          >
            {!isBottom && appBarJsx}
            {isBottom && bottomBarJsx}
          </Toolbar>
        </NVAppBar>
      </Box>
    </>
  );
};
